import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckboxInactive = function SvgCheckboxInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 24A2.25 2.25 0 0 1 0 21.75V2.25A2.25 2.25 0 0 1 2.25 0h19.5A2.25 2.25 0 0 1 24 2.25v19.5A2.25 2.25 0 0 1 21.75 24H2.25Zm0-1.5h19.5a.75.75 0 0 0 .75-.75V2.25a.75.75 0 0 0-.75-.75H2.25a.75.75 0 0 0-.75.75v19.5c0 .414.336.75.75.75Z",
    fillRule: "evenodd"
  })));
};

export { SvgCheckboxInactive as ReactComponent };
//# sourceMappingURL=checkbox-inactive.svg.js.map
